
import { Component } from 'vue-property-decorator';
import Vue from 'vue';

@Component({name: 'cell-border-style'})
export default class CellBorderStyle extends Vue {

}
